import React from 'react';
import { Layout } from 'antd';
import { Link as _Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from './logo-white.png';
import colors from 'theme/colors';
import Search from 'components/Nav/Search';

const TMTHeader = styled(Layout.Header)`
  background-color: ${colors.gray2} !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px !important;
  @media (max-width: 786px) {
    padding: 0 10px !important;  
  }
`;

const Logo = styled.img.attrs({
  src: logo,
})`
  width: 72px;
  @media (max-width: 786px) {
    width: 58px;
  }
`;

const Link = styled(_Link)`
  display: inherit;
`;

const HeaderNav = () => (
  <TMTHeader>
    <Link to="/dashboard">
      <Logo />
    </Link>
    <Search />
  </TMTHeader>
);

export default HeaderNav;



// WEBPACK FOOTER //
// ./src/components/Nav/HeaderNav/index.js